export const faqs = [
  {
    question: "What is Daily Dish?",
    answer:
      "Daily Dish is a modern web platform designed to help users discover diverse and curated meal recipes. It features trending dishes, ingredient-based search, and personalized food recommendations tailored to your taste.",
  },
  {
    question: "Is there a cost to using Daily Dish?",
    answer:
      "No, Daily Dish is entirely free to use. Users can browse recipes, view trending meals, and explore content without any subscription or payment requirements.",
  },
  {
    question: "How does Daily Dish determine trending meals?",
    answer:
      "Trending meals are identified based on real-time user search behavior and keyword frequency. The system dynamically updates the list to showcase the most popular and in-demand dishes at any given time.",
  },
  {
    question: "Can I save or bookmark meals I like?",
    answer:
      "Meal saving and bookmarking features are currently in development. Once available, users will be able to create personal collections and revisit their favorite dishes with ease.",
  },
  {
    question: "Do I need to create an account to use Daily Dish?",
    answer:
      "No account is required to explore meals or search recipes. However, registering an account in the future will unlock personalized features like saved meals, tailored suggestions, and subscription preferences.",
  },
];
